import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, inject } from '@angular/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocaleManager } from '@bryntum/scheduler';
import { Translation } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { Settings } from 'luxon';
import localeNl from '@angular/common/locales/nl-BE';
import '../../../assets/i18n/scheduler.locale.En.js';
import '../../../assets/i18n/scheduler.locale.Nl.js';

import { EnvNameEnum, environment } from '@dps/env';
import { AppLocaleEnum } from './app-locale.enum';

const APP_LOCALE_KEY = 'dpsLocale';
const APP_TO_SCHEDULER_LOCALES_MAP: Record<AppLocaleEnum, string> = {
  [AppLocaleEnum.EN]: 'En',
  [AppLocaleEnum.NL]: 'Nl',
};

@NgModule({
  providers: [
    { provide: LOCALE_ID, useValue: AppLocaleEnum.NL },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'EUR',
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ failOnError: true }),
    }),
  ],
})
export class I18nModule {
  private translateService = inject(TranslateService);
  private primeConfig = inject(PrimeNG);

  constructor() {
    registerLocaleData(localeNl, AppLocaleEnum.NL);
    this.translateService.addLangs(Object.values(AppLocaleEnum));
    let defaultLocale = localStorage.getItem(APP_LOCALE_KEY);
    if (!defaultLocale || !this.translateService.getLangs().includes(defaultLocale)) {
      defaultLocale = environment.envName === EnvNameEnum.DEV ? AppLocaleEnum.EN : AppLocaleEnum.NL;
    }
    this.translateService.setFallbackLang(defaultLocale);
    this.translateService.use(defaultLocale);

    this.translateService.onLangChange.subscribe(({ lang, translations }) => {
      document.documentElement.lang = lang;
      localStorage.setItem(APP_LOCALE_KEY, lang);
      this.primeConfig.setTranslation(translations['primeng'] as Translation);
      Settings.defaultLocale = lang;
      LocaleManager.applyLocale(APP_TO_SCHEDULER_LOCALES_MAP[lang as AppLocaleEnum]);
    });
  }
}
